import React from 'react';
import { IconProps } from './typing';

const LinkExternal = ({
  iconSize = 16,
  background = 'none',
  color = "currentColor"
}: IconProps) => (
  <svg
    width={iconSize}
    height={iconSize}
    viewBox={`0 0 ${iconSize} ${iconSize}`}
    fill={background}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.32361 1.23203C14.2771 0.905359 14.3395 0.925192 14.7018 1.28161C15.0833 1.67303 15.1019 1.77628 14.7385 7.64461L12.7587 7.52211C12.7988 6.87497 12.8482 6.28782 12.8922 5.76504C12.9371 5.2313 12.9764 4.76466 12.9944 4.36978L6.85245 10.493L5.45361 9.08836L11.5967 2.98203C11.1887 2.9971 10.731 3.03568 10.2113 3.07948C9.68548 3.12379 9.09628 3.17344 8.43095 3.20953L8.32361 1.23203Z"
      fill={color}
    />
    <path
      d="M14.4155 9.75784H12.4333V13.0193H2.98275V3.56342H6.25V1.58301H1V14.9997H14.4155V9.75784Z"
      fill={color}
    />
  </svg>
);

export default LinkExternal;
